"use client";

import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import { useRouter } from "next/navigation";
import { useGlobalData } from "@/contexts/GlobalData";
import { cn } from "@/lib/utils";
export interface PageHeaderPropsType extends GeneralPropsType {
  isBack?: boolean;
  overrideBackAction?: (data?: any) => any;
  iconClassName?: string;
  childrenClassName?: string;
  style?: React.CSSProperties;
  rightPack?: React.ReactNode;
}
function PageHeader({
  children,
  className,
  isBack = true,
  overrideBackAction,
  iconClassName,
  childrenClassName,
  style,
  rightPack
}: PageHeaderPropsType) {
  const {
    getIcon,
    hapticFeedback,
    translate
  } = useGlobalData();
  const router = useRouter();
  const back = () => {
    try {
      router.back();
      hapticFeedback.impactOccurred("medium");
    } catch (err) {}
  };
  return <div style={style} className={clsx("relative flex items-center w-full p-3", styles.container, className)} data-sentry-component="PageHeader" data-sentry-source-file="index.tsx">
            <DynamicFontSize className={clsx("absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white", childrenClassName)} fontSize={16} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                {children}
            </DynamicFontSize>

            {isBack && <button className="flex items-center cursor-pointer active:-translate-x-2 mr-auto duration-150" onClick={overrideBackAction ?? back}>
                    <DynamicSizeIcon width={24} icon={getIcon("back_arrow")} className={cn("", iconClassName)} />
                    <DynamicFontSize className="text-white capitalize" fontSize={12}>
                        {translate("header_back")}
                    </DynamicFontSize>
                </button>}
            {rightPack}
        </div>;
}
export default PageHeader;